// extracted by mini-css-extract-plugin
export var actionButton = "_ls-t";
export var buttonContainer = "_ls-0";
export var buttonContainer2 = "_ls-1";
export var buttonSection = "_ls-2";
export var details = "_ls-3";
export var dropdownItem = "_ls-5";
export var dropdownItemsContainer = "_ls-4";
export var fileInput = "_ls-r";
export var headerButton = "_ls-6";
export var icon = "_ls-7";
export var input = "_ls-8";
export var macroListItem = "_ls-9";
export var mainContent = "_ls-a";
export var microText = "_ls-b";
export var modal = "_ls-w";
export var optionsButton = "_ls-c";
export var paperclip = "_ls-s";
export var pillContent = "_ls-d";
export var preview = "_ls-e";
export var preview2 = "_ls-f";
export var quillEditor = "_ls-q";
export var selectedMacro = "_ls-g";
export var sidebar = "_ls-h";
export var sidebarHeader = "_ls-j";
export var sidebarList = "_ls-i";
export var sidebarListItem = "_ls-k";
export var sidebarSearch = "_ls-l";
export var snoozeDurationWrapper = "_ls-v";
export var statusPillContainer = "_ls-m";
export var tagsContainer = "_ls-n";
export var unselectedMacro = "_ls-o";
export var variable = "_ls-u";
export var wrapper = "_ls-p";